{
    "ChanneltypesLabel": "Type",
    "ChanneltypesOptionAny": "[Elk kanaal]",
    "ChanneltypesOptionVoice": "Spraakoproepen",
    "ChanneltypesOptionChat": "Chats",
    "ChanneltypesOptionEmail": "E-mails",
    "CalltypedirectionLabel": "Oproeptype \/ richting:",
    "CalltypedirectionOptionAny": "[Elk oproeptype]",
    "CalltypedirectionOptionUnknownorinitiating": "of hier slepen en neerzetten.",
    "CalltypedirectionOptionInbound": "Alleen inkomend",
    "CalltypedirectionOptionOutbound": "Alleen uitgaand",
    "CalltypedirectionOptionExternalAll": "Alleen extern",
    "CalltypedirectionOptionExternalInbound": "Extern (alleen inkomend)",
    "CalltypedirectionOptionExternalOutbound": "Extern (alleen uitgaand)",
    "CalltypedirectionOptionExternalTrktotrk": "Externe Trunk-To-Trunk",
    "CalltypedirectionOptionInternalAll": "Alleen intern",
    "CalltypedirectionOptionInternalInbound": "Intern (alleen inkomend)",
    "CalltypedirectionOptionInternalOutbound": "Intern (alleen uitgaand)",
    "AnswertypeLabel": "Antwoordtype:",
    "ClicalleridreceivedAny": "[Any]",
    "ClicalleridreceivedNone": "Zonder CLI\/Beller-ID",
    "ClicalleridreceivedReceived": "Met CLI\/Beller-ID",
    "AnswertypeOptionAny": "[Elk antwoordtype]",
    "AnswertypeOptionNotans": "Niet geantwoord",
    "AnswertypeOptionAns": "beantwoord",
    "AnswertypeOptionAbandoned": "Verlaten",
    "AnswertypeOptionAdvancedFrom": "Geavanceerd Van",
    "AnswertypeOptionAdvancedTo": "Geavanceerd naar",
    "AnswertypeOptionOverflowedFrom": "Overgelopen uit",
    "AnswertypeOptionOverflowedTo": "Overstroomd",
    "ClicalleridreceivedLabel": "CLI \/ Beller-ID ontvangen:",
    "DiddigitsLabel": "DDI-cijfers:",
    "AccountcodesLabel": "Accountcode(s):",
    "CallidentifierLabel": "Oproepidentificatie (Telefoonplatform):",
    "SubjectfilterLabel": "Onderwerpfilter:",
    "TreatconfcallasExternalLabel": "Conferentiegesprek als extern behandelen:",
    "MiscellaneousFiltering_SectionHeader": "Diverse filtering",
    "MiscellaneousFiltering_AnyPlaceholder": "[Any]",
    "NAME": "MiscellaneousFiltering"
}